import { render, staticRenderFns } from "./ProcessLeaver.vue?vue&type=template&id=4a45d7d4&"
import script from "./ProcessLeaver.vue?vue&type=script&lang=ts&"
export * from "./ProcessLeaver.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports